import React, { useEffect, useRef, useState } from "react";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import { Esercizio } from "../interfaces/Esercizio";
import DeleteIcon from '@mui/icons-material/Delete';
import { Chip, Box } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

interface VideoTrackProps {
  title: string;
  description: string;
  acceptedFileType: string;
  file: File | string | null;
  field: keyof Esercizio;
  handleChange: <K extends keyof Esercizio>(key: K, value: Esercizio[K]) => void;
  fast?: boolean;
}

const VideoTrack: React.FC<VideoTrackProps> = ({ title, description, acceptedFileType, file, field, handleChange, fast }) => {
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [videoURL, setVideoURL] = useState<string | undefined>(undefined);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFile = event.target.files?.[0] || null;

    if (selectedFile) {
      handleChange(field, selectedFile);
      handleChange("filename_video", selectedFile.name);
      const url = URL.createObjectURL(selectedFile);
      setVideoURL(url);

      return () => {
        URL.revokeObjectURL(url);
      };
    } else {
      setVideoURL(undefined);
    }
  };

  const handleRemoveFile = () => {
    setVideoURL(undefined);
    handleChange(field, null);
    handleChange("filename_video", null);
  };

  const handleChangeFile = () => {
    setVideoURL(undefined);
    fileInputRef.current?.click();
  };

  return (
    <>
      <h5 className="text-lg font-semibold">{title}</h5>

      {fast ? (
         <>
          <input
            type="file"
            accept={acceptedFileType}
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          {!file && (

            <button
              className="btn flex gap-2 mb-4 btn-light"
              style={{ backgroundColor: "#e7e7e7", color: "black" }}
              onClick={handleButtonClick}
            >
              <FileUploadIcon />
              Carica file
            </button>
          )}
          {file && (<>
            <div className="row align-items-center">
              <div className="col-8">
                <video
                  src={typeof file === "string" ? file : videoURL}
                  controls
                  style={{ height: "21vh", width: "100%" }}
                />
              </div>
              <div className="col text-end">
                <button
                  className="btn flex gap-2 mb-4 btn-light"
                  style={{ backgroundColor: "#e7e7e7", color: "black" }}
                  onClick={handleRemoveFile}
                >
                  <DeleteIcon fontSize="small" /> Elimina
                </button>
              </div>
            </div>
          </>
          )}
        </>
      ) : (
        <>
          <p className="text-sm" style={{ color: "gray" }}>{description}</p>
          <div className="text-center">
            <input
              type="file"
              accept={acceptedFileType}
              ref={fileInputRef}
              style={{ display: "none" }}
              onChange={handleFileChange}
            />
            {file ? (
              <>
                <div className="border p-3 rounded-3 bg-light">
                  <div className="text-center m-1">
                    <Chip
                      label={typeof file === "string" ? file.split('/').pop() : "Video caricato"}
                      onDelete={handleRemoveFile}
                      deleteIcon={
                        <Box
                          sx={{
                            backgroundColor: 'black',
                            borderRadius: '50%',
                            padding: '2px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <CloseIcon sx={{ color: 'white', fontSize: 18 }} />
                        </Box>
                      }
                      sx={{
                        backgroundColor: 'black',
                        color: 'white',
                      }}
                    />
                  </div>
                  <video
                    src={typeof file === "string" ? file : videoURL}
                    controls
                    style={{ height: "21vh", width: "auto" }}
                  />
                </div>
              </>
            ) : (
              <>
                <div className="border p-3 rounded-3 bg-light">
                  <p>Trascina e rilascia <br />o</p>
                  <button
                    className="btn flex items-center gap-2 mb-4"
                    style={{ backgroundColor: "#1c492d", color: "white" }}
                    onClick={handleButtonClick}
                  >
                    <FileUploadIcon />
                    Carica file
                  </button>
                  <p className="text-sm" style={{ color: "gray" }}>Nessun file caricato</p>
                </div>
              </>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default VideoTrack;
